import React from "react";
import '../css/Promo.css';


function Promo() {
  return ( 
    <section id="capacity">
        <div class="container_content">
               
            <h1 class="text-white">Sewa Hiace Mulai dari 800rb </h1>
         
        </div>
    </section>
  );
}
   
export default Promo;